import React, { useContext, useEffect, useState } from "react";
import {
  procPublishedState,
  PublishedContext
} from "../context/published-state";

const withPublishedLimit = (WrappedComponent: any) => {
  const WithPublishedLimit = (props: any) => {
    const { comic } = props;
    const setPublishedStateFunc = useContext(PublishedContext)[1];

    useEffect(() => {
      // stagingモードでは公開期間は無視する。
      if (comic.isStaging) {
        setPublishedStateFunc({
          soon: false,
          late: false,
          init: false
        });
      } else {
        const asyncWrapper = async () => {
          // ※PublishedStateの書き換えは関数は
          // PublishedContext.Provider で初期値として代入しているので、
          // それより下層でのみ有効。
          const contextState: PublishedState = await procPublishedState(
            comic.publishFrom,
            comic.publishTo
          );
          setPublishedStateFunc(contextState);
        };
        asyncWrapper();
      }
    }, []);

    return <WrappedComponent {...props} />;
  };
  return WithPublishedLimit;
};

export default withPublishedLimit;
